import { lazy } from 'react';

const AdvancesToSupplierNonTrade = lazy(() =>
  import('../pages/AdvancesToSupplierNonTrade/index'),
);

const advancesToSupplierNonTradeRoute = {
  public: [],
  auth: [
    {
      name: 'advances_to_supplier_non_trade',
      path: '/finance-and-accounting/advances-to-supplier-non-trade',
      component: AdvancesToSupplierNonTrade,
    },
  ],
};

export default advancesToSupplierNonTradeRoute;
